export const featuresDependencies = {
    discount_finder: ['gdpr_account_manager'],
};
export const billingPlans = {
    start: {
        amount: 59,
        fees: {
            europe: {
                default: {
                    flat: 25,
                    percent: 2.9,
                },
            },
            others: {
                default: {
                    flat: 25,
                    percent: 2.9,
                },
            },
        },
        features: [
            'button',
            'quantity_selector',
            'button_new_text',
            'pre_purchase_pickup',
            'gdpr_marketing_manager',
            'gdpr_account_manager',
        ],
    },
    grow: {
        amount: 199,
        fees: {
            europe: {
                default: {
                    flat: 25,
                    percent: 2.7,
                },
            },
            others: {
                default: {
                    flat: 25,
                    percent: 2.9,
                },
            },
        },
        features: [
            'button',
            'quantity_selector',
            'button_new_text',
            'button_price_strikethrough',
            'pre_purchase_pickup',
            'product_stock_indicator',
            'gdpr_marketing_manager',
            'gdpr_account_manager',
        ],
    },
    prime: {
        amount: 299,
        fees: {
            europe: {
                default: {
                    flat: 25,
                    percent: 2.5,
                },
            },
            others: {
                default: {
                    flat: 25,
                    percent: 2.9,
                },
            },
        },
        features: [
            'button',
            'quantity_selector',
            'button_new_text',
            'button_price_strikethrough',
            'pre_purchase_pickup',
            'product_stock_indicator',
            'button_new_text',
            'add_and_buy',
            'google_pay',
            'note_from_merchant',
            'gdpr_marketing_manager',
            'gdpr_account_manager',
        ],
    },
    custom: {
        amount: 0,
        fees: {
            europe: {
                default: {
                    flat: 25,
                    percent: 1.4,
                },
            },
            others: {
                default: {
                    flat: 25,
                    percent: 2.9,
                },
            },
        },
        features: [
            'button',
            'quantity_selector',
            'product_stock_indicator',
            'gdpr_marketing_manager',
            'gdpr_account_manager',
        ],
    },
};
export const BUTTON_STATES = ['IDLE', 'PENDING', 'CREATED', 'ERROR', 'CANCELLED'];
//# sourceMappingURL=shop.js.map